<div
  class="autocomplete-field"
  #originEl
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
  (keydown)="onKeydown($event)">
  <andor-text-field
    [formControl]="searchControl"
    [label]="label()"
    [placeholder]="placeholder()"
    [labelTooltip]="labelTooltip()"
    [inlineActions]="inlineActions()"
    [inlineActionsPosition]="inlineActionsPosition()"
    autocomplete="off"></andor-text-field>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="showPanel()"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="overlayWidth ?? 0"
  [cdkConnectedOverlayPush]="true"
  (overlayOutsideClick)="open.set(false)">
  <div class="ac-panel">
    <div class="ac-list" role="listbox">
      @for (item of items(); track trackItem($index, item); let i = $index) {
        <div
          class="ac-option"
          role="option"
          [class.active]="i === activeIndex()"
          [attr.aria-selected]="i === activeIndex()"
          (mousedown)="$event.preventDefault()"
          (mouseenter)="activeIndex.set(i)"
          (click)="select(item)">
          @if (optionTpl(); as tpl) {
            <ng-container
              *ngTemplateOutlet="
                tpl;
                context: { $implicit: item, active: i === activeIndex() }
              "></ng-container>
          } @else {
            {{ displayWith()(item) }}
          }
        </div>
      }
      @if (items().length === 0 && emptyText().length > 0) {
        <div class="ac-empty">{{ emptyText() }}</div>
      }
    </div>
  </div>
</ng-template>
